import { render } from "./ImageTextButton.vue?vue&type=template&id=b6ba669c&scoped=true"
import script from "./ImageTextButton.vue?vue&type=script&lang=js"
export * from "./ImageTextButton.vue?vue&type=script&lang=js"

import "./ImageTextButton.vue?vue&type=style&index=0&id=b6ba669c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6ba669c"]])

export default __exports__